import React from 'react';
import styled from 'styled-components';

const BoxWrapper = styled.div`
  box-shadow: 0px 10px 30px -12px rgba(0, 0, 0, 0.42);
  background-color: #ffffff;
  border-radius: 5px;
  border: 1px solid #dddddd;
`;

const Box = ({ children, ...props }) => {
  return <BoxWrapper {...props}>{children}</BoxWrapper>;
};

export default Box;
